import { render, staticRenderFns } from "./TodaysReminder.vue?vue&type=template&id=a78535e6&"
import script from "./TodaysReminder.vue?vue&type=script&lang=js&"
export * from "./TodaysReminder.vue?vue&type=script&lang=js&"
import style0 from "./TodaysReminder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports